import { useEffect } from 'react';
import { useAccount, useChainId, useConfig } from 'wagmi';

import { initWeb3Signer } from 'src/utils/web3Signer';

function Web3SignerBootstrap() {
  const { address } = useAccount();
  const chainId = useChainId();
  const config = useConfig();

  useEffect(() => {
    if (address && chainId && config) {
      initWeb3Signer({ address, chainId, config });
    }
  }, [address, chainId, config]);

  return null;
}

export default Web3SignerBootstrap;
